export default {
  noPowerTip:
    'It\'s not what you want, but we\'re serious. I want to tell you in a special way that you don\'t have permission to access this page or the file is invalid. You can contact the website administrator to solve the problem faster or go back home page to view another page.'
}
